import React from "react";
import styles from "./OccasionCarouselItem.module.css";
import { Link } from "react-router-dom";
function OccasionCarouselItem({ occasion, isActive }) {
  return (
    <div className={styles.OccasionCarouselItem}>
      <div className={styles.Title}>{occasion.Name}</div>
      <img
        src={occasion.Image.src}
        alt={occasion.Image.alt}
        className={styles.OccasionImage}
      />
      <div className={styles.Description}>{occasion.Description}</div>
      <Link
        to={`/occasions/${occasion.FriendlyName}`}
        styles={{
          textDecoration: "none",
        }}
      >
        <div
          className={styles.OccasionButton}
          style={{
            backgroundColor: occasion.Theme
              ? occasion.Theme.Colour
                ? occasion.Theme.Colour
                : "var(--mh-yellow-color)"
              : "var(--mh-yellow-color)",
            color: occasion.Theme
              ? occasion.Theme.FontColor
                ? occasion.Theme.FontColor
                : "#000"
              : "#000",
          }}
        >
          {occasion.Theme?.ButtonText ?? occasion.Name}
        </div>
      </Link>
    </div>
  );
}

export default OccasionCarouselItem;
